(function(){"use strict";var r;try{if(typeof document<"u"){var e=document.createElement("style");e.nonce=(r=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:r.content,e.appendChild(document.createTextNode("._summary_1obdp_3,._summary_collapsed_1obdp_4,._summary_collapsed_1obdp_4 *,._summary_1obdp_3 *{--size-extra-small: .0625rem;--size-small: .975rem;--size-medium: 1.25rem;--size-x-medium: .375rem;--size-large: .3rem;--size-extra-large: .25rem;--size-extra-extra-large: 1.68rem;--main-price-size: 1.5rem}._summary_1obdp_3,._summary_item_1obdp_18,._summary_item_children_1obdp_19,._summary_collapsed_1obdp_4{display:flex;flex-direction:column;gap:var(--s)}._summary_item_content_1obdp_26,._summary_subitem_content_1obdp_27{display:flex;color:var(--grey-700-66);flex-direction:column;gap:var(--s)}._summary_back_1obdp_34{background-color:#fff;padding:1.5rem 2rem 2rem}._summary_subitem_click_1obdp_39{-webkit-text-decoration:underline!important;text-decoration:underline!important;color:var(--neutrals-black);cursor:pointer}._summary_item_body_1obdp_45{display:flex;align-items:flex-end;justify-content:space-between;color:var(--grey-700-66);padding-bottom:var(--xxs)}._summary_item_box_total_1obdp_53{display:flex;align-items:center;justify-content:space-between;border-top:var(--size-extra-small) solid var(--grey-200-ee);padding:var(--s) 0 var(--xxs)}._summary_total_1obdp_61{padding-bottom:var(--s)}._summary_icon_1obdp_65{width:var(--size-small);color:var(--primary-red-500)}._summary_icon_go_1obdp_70{rotate:90deg}._summary_icon_return_1obdp_74{rotate:-90deg}._summary_price_container_1obdp_78{display:flex;flex-direction:column}._summary_price_1obdp_78{display:flex;flex-flow:row wrap;justify-content:space-between}._summary_price_1obdp_78>*:first-child{padding-right:var(--xxs)}._summary_subtitle_1obdp_91{color:var(--grey-700-66)}._summary_display_row_1obdp_95{display:flex;align-items:center}._summary_price_align_1obdp_100{align-self:end}._summary_text_fit_1obdp_104{max-width:70%}._summary_item_title_1obdp_108{padding-left:var(--xxs)}._summary_item_icon_children_1obdp_112{padding-left:var(--size-medium)}._summary_item_children_1obdp_19{gap:var(--size-extra-small)}._summary_subitem_title_1obdp_120{display:flex;align-self:start;gap:var(--size-large)}._summary_passengers_1obdp_126{border-bottom:var(--size-extra-small) solid var(--grey-200-ee);padding-bottom:var(--size-x-medium);margin-bottom:var(--size-x-medium)}._summary_price_black_1obdp_132{color:var(--neutrals-black)}._summary_subitem_icon_1obdp_136{position:relative;width:var(--s);min-width:var(--s)}._summary_subitem_content_1obdp_27{gap:var(--xs)}._summary_accordion_1obdp_146{padding-top:var(--xs);border-top:var(--size-extra-small) solid var(--grey-200-ee)}._summary_accordion_header_1obdp_151{gap:var(--xxs)!important;color:var(--grey-700-66)!important;width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important;align-self:end}._summary_accordion_header_1obdp_151 :hover{color:var(--primary-red-500)!important}._summary_1obdp_3>*:not(:last-child){padding-bottom:var(--xs);border-bottom:var(--size-extra-small) solid var(--grey-200-ee)}._summary_box_quotes_1obdp_167{align-items:center;border-top:var(--size-extra-small) solid var(--grey-200-ee)}._summary_wrapper_column_1obdp_172{display:flex;flex-direction:column}")),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { jsxs as o, jsx as e, Fragment as O } from "react/jsx-runtime";
import { B as c } from "./Box-f1x-hS6O.js";
import b from "clsx";
import { useTranslation as y } from "react-i18next";
import { u as U } from "./useResponsiveCollapse-BypPwAJ4.js";
import { w as z } from "./with-providers-Btcblyau.js";
import { useState as J, memo as N } from "react";
import { I as C } from "./Icon-uSQ2CWO_.js";
import { T as u } from "./Text-xSFugpp6.js";
import { A as T } from "./Accordion-BFEzqiEq.js";
import { E as h } from "./ErrorBoundaryProvider-BjV4GFsT.js";
const G = "_summary_1obdp_3", Y = "_summary_collapsed_1obdp_4", q = "_summary_item_1obdp_18", j = "_summary_item_children_1obdp_19", V = "_summary_item_content_1obdp_26", Q = "_summary_subitem_content_1obdp_27", K = "_summary_back_1obdp_34", X = "_summary_subitem_click_1obdp_39", W = "_summary_item_body_1obdp_45", Z = "_summary_item_box_total_1obdp_53", rr = "_summary_total_1obdp_61", er = "_summary_icon_1obdp_65", tr = "_summary_icon_go_1obdp_70", ar = "_summary_icon_return_1obdp_74", mr = "_summary_price_container_1obdp_78", sr = "_summary_price_1obdp_78", ir = "_summary_subtitle_1obdp_91", nr = "_summary_display_row_1obdp_95", or = "_summary_price_align_1obdp_100", cr = "_summary_text_fit_1obdp_104", _r = "_summary_item_title_1obdp_108", lr = "_summary_item_icon_children_1obdp_112", ur = "_summary_subitem_title_1obdp_120", dr = "_summary_passengers_1obdp_126", yr = "_summary_price_black_1obdp_132", pr = "_summary_subitem_icon_1obdp_136", Sr = "_summary_accordion_1obdp_146", hr = "_summary_accordion_header_1obdp_151", br = "_summary_box_quotes_1obdp_167", Nr = "_summary_wrapper_column_1obdp_172", i = {
  summary: G,
  summary_collapsed: Y,
  summary_item: q,
  summary_item_children: j,
  summary_item_content: V,
  summary_subitem_content: Q,
  summary_back: K,
  summary_subitem_click: X,
  summary_item_body: W,
  summary_item_box_total: Z,
  summary_total: rr,
  summary_icon: er,
  summary_icon_go: tr,
  summary_icon_return: ar,
  summary_price_container: mr,
  summary_price: sr,
  summary_subtitle: ir,
  summary_display_row: nr,
  summary_price_align: or,
  summary_text_fit: cr,
  summary_item_title: _r,
  summary_item_icon_children: lr,
  summary_subitem_title: ur,
  summary_passengers: dr,
  summary_price_black: yr,
  summary_subitem_icon: pr,
  summary_accordion: Sr,
  summary_accordion_header: hr,
  summary_box_quotes: br,
  summary_wrapper_column: Nr
}, d = (a) => {
  const { icon: r, number: t, text: m, price: s, children: n } = a;
  return /* @__PURE__ */ o(
    c,
    {
      className: b((r || t || m) && n ? i.summary_subitem_content : i.summary_subtitle),
      children: [
        /* @__PURE__ */ o(c, { className: i.summary_price, children: [
          /* @__PURE__ */ o(c, { className: i.summary_subitem_title, children: [
            r && /* @__PURE__ */ e(C, { className: i.summary_subitem_icon, name: r }),
            (m || t) && /* @__PURE__ */ e(u, { className: r && i.summary_subitem_title, as: "span", font: "verdana", size: "lg-bold", children: t ? `${String(t)} ${String(m)}` : m })
          ] }),
          s && /* @__PURE__ */ e(u, { className: i.summary_price_black, font: "verdana", size: "lg-regular", children: s })
        ] }),
        /* @__PURE__ */ e(c, { className: r ? i.summary_item_icon_children : i.summary_item_children, children: n })
      ]
    }
  );
};
d.displayName = "SummarySubItem";
const l = (a) => {
  const { amountEnd: r, amount: t, text: m, price: s, onClick: n } = a;
  return /* @__PURE__ */ o(c, { className: i.summary_item_body, children: [
    /* @__PURE__ */ e(u, { className: i.summary_item_content, font: "verdana", size: "lg-regular", children: !r && t ? `${String(t)} ${m}` : m }),
    /* @__PURE__ */ e(
      u,
      {
        className: b({
          [i.summary_price_black]: r,
          [i.summary_subitem_click]: n
        }),
        font: "verdana",
        size: "lg-regular",
        onClick: n && n,
        children: r && t ? `${String(t)} x ${String(s)}` : s
      }
    )
  ] });
};
l.displayName = "SummaryArticle";
const I = (a) => {
  const [r, t] = J(!0), { textHide: m, textShow: s } = a;
  return /* @__PURE__ */ e(
    T.Header,
    {
      className: i.summary_accordion_header,
      onClick: () => {
        t((n) => !n);
      },
      children: /* @__PURE__ */ e(u, { className: i.summary_accordion_title, as: "span", font: "verdana", size: "md-regular", children: r ? s : m })
    }
  );
};
I.displayName = "SummaryAccordionHeader";
const A = (a) => {
  const { triggerPosition: r = "bottom", textShow: t, textHide: m, children: s } = a;
  return /* @__PURE__ */ e(T, { type: "single", children: /* @__PURE__ */ o(T.Item, { value: "summary-accordion", children: [
    r === "top" && /* @__PURE__ */ e(I, { textShow: t, textHide: m }),
    /* @__PURE__ */ e(T.Content, { children: /* @__PURE__ */ e(c, { className: i.summary_item, children: s }) }),
    r === "bottom" && /* @__PURE__ */ e(I, { textShow: t, textHide: m })
  ] }) });
};
A.displayName = "SummaryAccordion";
const S = (a) => {
  const { icon: r, title: t, titleColor: m, children: s, total: n } = a;
  return /* @__PURE__ */ o(c, { className: i.summary_item, children: [
    t && /* @__PURE__ */ o(c, { className: i.summary_display_row, children: [
      r && /* @__PURE__ */ e(
        C,
        {
          className: b(i.summary_icon, {
            [i.summary_icon_go]: r === "go",
            [i.summary_icon_return]: r === "return"
          }),
          name: "vuelos"
        }
      ),
      /* @__PURE__ */ e(
        u,
        {
          className: r && i.summary_item_title,
          style: { color: m },
          font: "iberia-headline",
          size: "sm-regular",
          children: t
        }
      )
    ] }),
    s,
    n && /* @__PURE__ */ o(c, { className: i.summary_item_box_total, children: [
      /* @__PURE__ */ e(u, { className: i.summary_text_fit, font: "verdana", size: "lg-bold", children: n.title }),
      /* @__PURE__ */ e(u, { className: i.summary_price_align, font: "verdana", size: "lg-bold", children: n.price })
    ] })
  ] });
};
S.displayName = "SummaryItem";
const gr = {
  CABINA: "maleta-15kg",
  EQMANO: "maleta-15kg",
  EQBODEGA: "equipaje-10-14kg",
  ASIENTO: "asiento",
  ASIENTOPREFERENTE: "asiento-upgrade",
  ASIENTOXL: "asiento-plus",
  ASIENTODELANTERO: "asiento-delantero",
  CAMBIO: "calendario",
  REEMBOLSO: "calendario-reembolso",
  CHECKINDESK: "validar",
  SALAVIP: "sala-vip",
  FASTTRACK: "fast-track",
  TARJEMBANTIC: "passbook-tarjeta-embarque",
  EQPPRIOR: "embarque-prioritario",
  COMIDA: "bandeja-comida",
  EMBARQUE: "embarque-prioritario",
  AVIO: "avios-filled",
  WIFI: "alerta"
}, Tr = (a) => gr[a], D = ({ segment: a, collapsed: r }) => {
  const { t } = y("summary");
  return /* @__PURE__ */ o(O, { children: [
    /* @__PURE__ */ e(
      x,
      {
        fragment: a.departure,
        route: a.routeFormatted,
        routeCode: a.routeCodeFormatted,
        collapsed: r
      }
    ),
    !r && /* @__PURE__ */ o(A, { textShow: t("FLIGHT_DETAILS_CLOSED"), textHide: t("FLIGHT_DETAILS_OPENED"), children: [
      /* @__PURE__ */ e(
        x,
        {
          fragment: a.arrival,
          destinationCity: a.arrival.city,
          collapsed: r
        }
      ),
      /* @__PURE__ */ o(d, { text: a.flight.title, children: [
        /* @__PURE__ */ e(l, { text: a.flight.operatedBy }),
        /* @__PURE__ */ e(l, { text: a.flight.airplane })
      ] }),
      /* @__PURE__ */ e(d, { text: `${String(t("DURATION"))}  ${a.duration}` }),
      a.waitingTime && /* @__PURE__ */ e(d, { text: a.waitingTime })
    ] })
  ] });
};
D.displayName = "SummaryTripSegment";
const x = (a) => {
  const { t: r } = y("summary"), { fragment: t, route: m, routeCode: s, destinationCity: n, collapsed: _ = !1 } = a, { date: p, airport: E, terminal: f, cabin: g } = t;
  return /* @__PURE__ */ o(
    d,
    {
      text: n ? `${String(r("ARRIVAL"))} ${n}` : _ ? s : m,
      children: [
        /* @__PURE__ */ e(l, { text: p }),
        !_ && /* @__PURE__ */ o(O, { children: [
          /* @__PURE__ */ e(l, { text: E }),
          /* @__PURE__ */ e(l, { text: `${r("SUMMARY_TERMINAL")}  ${f}` }),
          g && /* @__PURE__ */ e(l, { text: `${String(r("CABIN"))}  ${g}` })
        ] })
      ]
    }
  );
};
x.displayName = "TripSegmentFragment";
const $ = (a) => {
  const { t: r } = y("summary"), { trip: t, indexTrip: m, isMultiTrip: s = !1, collapsed: n = !1 } = a;
  return /* @__PURE__ */ o(O, { children: [
    /* @__PURE__ */ e(
      S,
      {
        title: s ? `${String(r("JOURNEY"))} ${String(m + 1)}` : r(m === 0 ? "OUTBOUND_JOURNEY" : "RETURN_JOURNEY"),
        titleColor: s ? void 0 : "#d7192d",
        icon: s ? void 0 : m === 0 ? "go" : "return",
        children: t.segments.map((_) => /* @__PURE__ */ e(D, { segment: _, collapsed: n }, _.id))
      }
    ),
    !n && /* @__PURE__ */ o(S, { children: [
      /* @__PURE__ */ e(d, { text: `${String(r("FARE"))} ${t.fare.title}` }),
      /* @__PURE__ */ e(A, { textShow: r("FARE_DETAILS_COLLAPSED"), textHide: r("FARE_DETAILS_HIDE"), children: t.fare.items.map((_) => /* @__PURE__ */ e(d, { icon: Tr(_.code), text: _.title, children: /* @__PURE__ */ e(l, { text: _.text }) }, _.code)) })
    ] })
  ] });
};
$.displayName = "SummaryTrip";
const L = N(
  function(r) {
    const { trips: t, isMultiTrip: m, collapsed: s } = r;
    return /* @__PURE__ */ e(h, { children: t == null ? void 0 : t.map((n, _) => /* @__PURE__ */ e(
      $,
      {
        trip: n,
        indexTrip: _,
        isMultiTrip: m,
        collapsed: s
      },
      n.id
    )) });
  },
  (a, r) => JSON.stringify(a) === JSON.stringify(r)
);
L.displayName = "SummaryTrips";
const k = (a) => {
  const { t: r } = y("summary"), { ancillarie: t } = a;
  return /* @__PURE__ */ e(
    S,
    {
      title: r(`ANCILLARIES_${t.code}`),
      total: {
        title: r(`ANCILLARIES_TOTAL_${t.code}`),
        price: t.total
      },
      children: t.segments ? t.segments.map((m) => /* @__PURE__ */ e(d, { text: m.title, children: /* @__PURE__ */ e(c, { className: i.item__children, children: m.items.map((s) => /* @__PURE__ */ e(
        l,
        {
          text: s.description,
          price: s.price,
          amount: s.amount
        },
        s.code
      )) }) }, m.id)) : t.type && /* @__PURE__ */ e(c, { className: i.item__children, children: /* @__PURE__ */ e(l, { text: t.type, price: t.total }) })
    }
  );
};
k.displayName = "AncillarieItem";
const Ar = N(function({ title: r, subtitle: t, price: m, avios: s }) {
  return /* @__PURE__ */ o(c, { className: i.summary_price, children: [
    /* @__PURE__ */ o(c, { children: [
      /* @__PURE__ */ e(u, { font: "iberia-headline", size: "md-regular", children: r }),
      t && /* @__PURE__ */ e(u, { font: "verdana", size: "md-regular", children: t })
    ] }),
    /* @__PURE__ */ e(u, { font: "iberia-headline", size: "md-regular", children: s ? `${s} Avios + ${m}` : m })
  ] });
}), Er = ({ dccPrice: a = "", dccTitle: r }) => a.length === 0 ? null : /* @__PURE__ */ o(c, { className: i.summary_price, children: [
  /* @__PURE__ */ e(u, { font: "iberia-headline", size: "sm-regular", children: r }),
  /* @__PURE__ */ e(u, { font: "iberia-headline", size: "sm-regular", children: a })
] }), P = ({ title: a, price: r, dccTitle: t, subtitle: m, dccPrice: s, avios: n }) => /* @__PURE__ */ e(h, { children: /* @__PURE__ */ o(c, { className: i.summary_price_container, children: [
  /* @__PURE__ */ e(Ar, { title: a, subtitle: m, price: r, avios: n }),
  /* @__PURE__ */ e(Er, { dccPrice: s, dccTitle: t })
] }) });
P.displayName = "SummaryTotal";
const M = (a) => {
  const { t: r } = y("summary"), { passenger: t } = a, m = t.names.length > 1 ? `SOME_${t.type}` : t.type;
  return /* @__PURE__ */ o(
    d,
    {
      icon: t.type === "ADULT" ? "pasajero-masculino" : t.type === "CHILD" ? "ninos" : "bebes",
      text: r(m),
      number: t.names.length,
      children: [
        /* @__PURE__ */ e(c, { className: i.summary_passengers, children: t.names.map((s, n) => /* @__PURE__ */ e(l, { text: s }, `passenger_${String(n)}`)) }),
        t.avios && /* @__PURE__ */ e(
          l,
          {
            text: r("AVIOS"),
            price: `${t.avios} ${String(r("AVIOS"))}`,
            amount: t.names.length,
            amountEnd: !0
          }
        ),
        /* @__PURE__ */ e(
          l,
          {
            text: r("FARE"),
            price: t.fare,
            amount: t.names.length,
            amountEnd: !0
          }
        ),
        /* @__PURE__ */ e(
          l,
          {
            text: r("OPERATOR_FEES"),
            price: t.taxes,
            onClick: () => {
              a.onClick(t.type);
            }
          }
        )
      ]
    }
  );
};
M.displayName = "PassengerItem";
const v = N(
  function({ ancillaries: r }) {
    return /* @__PURE__ */ e(h, { children: r == null ? void 0 : r.map((t) => /* @__PURE__ */ e(k, { ancillarie: t }, t.code)) });
  },
  (a, r) => JSON.stringify(a) === JSON.stringify(r)
);
v.displayName = "SummaryAncillaries";
const F = N(
  function({ otherItems: r }) {
    const { t } = y("summary");
    return /* @__PURE__ */ e(h, { children: r == null ? void 0 : r.map((m) => {
      var _;
      let s = "", n = "";
      return m.type !== "ONHOLD" && m.type !== "JOURNEY" && (s = `OTHER_ITEMS_${m.type}`, m.type !== "OFFERS" && (n = `OTHER_ITEMS_TOTAL_${m.type}`)), /* @__PURE__ */ e(
        S,
        {
          title: t(s),
          total: m.total ? {
            title: t(n),
            price: m.total
          } : void 0,
          children: /* @__PURE__ */ e(d, { text: m.subtitle, price: m.price, children: (_ = m.items) == null ? void 0 : _.map((p) => /* @__PURE__ */ e(
            l,
            {
              amount: p.amount,
              text: p.description,
              price: p.price
            },
            p.code
          )) })
        },
        m.type
      );
    }) });
  },
  (a, r) => JSON.stringify(a) === JSON.stringify(r)
);
F.displayName = "SummaryOthers";
const fr = N(function({ passengers: r }) {
  const { t } = y("summary");
  return /* @__PURE__ */ e(h, { children: r && /* @__PURE__ */ e(
    S,
    {
      title: t("PASSENGERS"),
      total: {
        title: t("HEADER_FLIGHTS_TOTAL"),
        price: r.total
      },
      children: r.types.map((m, s) => /* @__PURE__ */ e(M, { passenger: m, onClick: r.onClick }, s))
    }
  ) });
}), H = (a) => {
  const { t: r } = y("summary"), {
    trips: t,
    isMultiTrip: m,
    passengers: s,
    ancillaries: n,
    otherItems: _,
    onholdPrice: p,
    avios: E,
    totalPrice: f,
    totalDcc: g,
    upgradingBid: R,
    collapsed: B
  } = a;
  return /* @__PURE__ */ o(h, { children: [
    /* @__PURE__ */ e(L, { isMultiTrip: m, trips: t, collapsed: B ?? !1 }),
    /* @__PURE__ */ e(fr, { passengers: s }),
    /* @__PURE__ */ e(v, { ancillaries: n }),
    /* @__PURE__ */ e(F, { otherItems: _ }),
    /* @__PURE__ */ e(
      P,
      {
        title: r(R ? "MAX_TO_PAY" : "TOTAL"),
        subtitle: R && r("UPGRADING_BIDS_PAYMENT") || p && r("TOTAL_ONHOLD_SUBTITLE"),
        dccTitle: r("FINAL_PRICE"),
        price: p || f,
        avios: E,
        dccPrice: g
      }
    )
  ] });
}, w = (a) => {
  const [r] = U({
    overThresholdCollapsed: a.collapsed ?? !1,
    underThresholdCollapsed: a.collapsed ?? !0
  });
  return r ? /* @__PURE__ */ e(Ir, { ...a }) : /* @__PURE__ */ e(xr, { ...a });
}, Ir = (a) => {
  const { t: r } = y("summary"), { trips: t, isMultiTrip: m, title: s } = a;
  return /* @__PURE__ */ o(c, { className: b(i.summary_collapsed, i.summary_back), children: [
    /* @__PURE__ */ e(S, { title: s ?? r("SUMMARY_TITLE") }),
    /* @__PURE__ */ e(L, { isMultiTrip: m, trips: t, collapsed: !0 }),
    /* @__PURE__ */ e(c, { className: i.summary_accordion, children: /* @__PURE__ */ e(
      A,
      {
        textShow: r("FLIGHT_DETAILS_CLOSED"),
        textHide: r("FLIGHT_DETAILS_OPENED"),
        triggerPosition: "top",
        children: /* @__PURE__ */ e(c, { className: i.summary, children: /* @__PURE__ */ e(H, { ...a }) })
      }
    ) })
  ] });
}, xr = (a) => {
  const { t: r } = y("summary");
  return /* @__PURE__ */ o(c, { className: b(i.summary, i.summary_back), children: [
    /* @__PURE__ */ e(S, { title: a.title ?? r("SUMMARY_TITLE") }),
    /* @__PURE__ */ e(H, { ...a })
  ] });
};
w.displayName = "Summary";
const Hr = z(w);
export {
  Hr as S
};
